import { Transition } from "components/shared/column";
import { featureModuleTypesEnum } from "helpers/enums";
import { paths } from "helpers/paths";
import React from "react";
import { CustomScroll } from "react-custom-scroll";
import { Link } from "react-router-dom";
import connect from "./container";

function IntegrationList(props) {
    const close = () => {
        const { history, back } = props;
        back ? back() : history.push(paths.root);
    };

    return (
        <Transition dir="left" wrapper="page-col--overflow-inherit" {...props}>
            <div className="page-book__list book-list list book-list--nofilter book-list--nopagination">
                <div className="book-list__head-wrap">
                    <div className="book-list__head">
                        <div className="book-list__head-close close close--sm" onClick={close} />
                        <div className="book-list__head-title">Интеграция</div>
                    </div>
                </div>
                <div className="list__body-wrap">
                    <div className="list__body content-wrapper">
                        <CustomScroll heightRelativeToParent="100%">
                            <div className="container-fluid">
                                <Link
                                    className="d-block reports__item"
                                    to={paths.integrationItem("parcel")}
                                    name="parcel"
                                >
                                    1. Почта России, СДЭК
                                </Link>
                                <Link
                                    className="d-block reports__item"
                                    to={paths.integrationItem("atisu")}
                                    name="atisu"
                                >
                                    2. ATI.SU
                                </Link>
                                {props.profile.availableFeatureModules.includes(
                                    featureModuleTypesEnum.KonturIntegration,
                                ) && (
                                    <Link
                                        className="d-block reports__item"
                                        to={paths.integrationItem("kontur")}
                                        name="kontur"
                                    >
                                        3. Контур.Диадок
                                    </Link>
                                )}
                            </div>
                        </CustomScroll>
                    </div>
                </div>
            </div>
        </Transition>
    );
}

export default connect(IntegrationList);
